export const insertParticipationComment = async ({ chargingPointUUID, payload }) => {
    try {

        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingPointUUID}/comment/participation`

        const api = await fetch(url.toString(), {
            method: 'POST',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify({
                ...payload
            }),
        })

        const response = await api.json()
        return response.data
    } catch (error) {
        console.error('Could not create comment', error)
    }
}

export const getParticipationComments = async (chargingPointUUID) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/${chargingPointUUID}/comments/participation`

        const api = await fetch(url, {
            method: 'GET',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not get comments')
    }

}

export const updateParticipationComment = async ({ commentUUID, status, user }) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/comment/participation/${commentUUID}`
        const isFinished = ['done', 'ignore'].includes(status)

        const api = await fetch(url, {
            method: 'PATCH',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
            body: JSON.stringify({
                status,
                user,
                isFinished
            }),
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not update comment')
    }

}

export const deleteParticipationComment = async (commentUUID) => {
    try {
        const url = `${process.env.VUE_APP_AWS_APIV3_BASE_URL}/chargingpoint/comment/participation/${commentUUID}`

        const api = await fetch(url, {
            method: 'DELETE',
            headers: {
                'x-api-key': process.env.VUE_APP_AWS_API_KEY,
            },
        })

        const response = await api.json()

        return response.data
    } catch (error) {
        console.log('Could not delete comment')
    }
}
